// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__1COLn","unreadBadge":"styles_unreadBadge__3aV_U","modalContent":"styles_modalContent__U0hfD","modal":"styles_modal__3jC-f"};